module.exports = __webpack_public_path__ + "img/sport-run.32d86037.jpg";